export default __webpack_public_path__ + "assets/ca.a8cabbf4.png";